// TODO Add a couple lines about each project
const data = [
  {
    title: 'Contrastive Learning for Enhancing Robust Scene Transfer in Vision-based Agile Flight.',
    image: '/images/projects/RPG-CL.gif',
    video_link: 'https://www.youtube.com/watch?v=4A4YyPgEWD8',
    slides_link: '',
    title_link: 'https://arxiv.org/abs/2309.09865',
    code_link: '',
    author: 'Jiaxu Xing, Leonard Bauersfeld, Yunlong Song, Chunwei Xing, Davide Scaramuzza',
    journal: 'ICRA',
    date: '2024',
    comments: '',
  },
  {
    title: 'Descriptellation: Deep Learned Constellation Descriptors.',
    video_link: 'https://www.youtube.com/watch?v=j_28-maRwmo&list=PL05BR7PIAwqAx0VgwNVHPepqPwg433qfx&index=1',
    title_link: 'https://arxiv.org/abs/2203.00567',
    code_link: 'https://github.com/ethz-asl/Descriptellation',
    slides_link: 'https://docs.google.com/presentation/d/15TJfORM8ugRDQLiqKYFq9NjYdliNyy4l9T3FXxn3TvI/edit?usp=sharing',
    image: '/images/projects/PLR.gif',
    author: 'Chunwei Xing, Xinyu Sun, Andrei Cramariuc, Samuel Gull, Jen Jen Chung, Cesar Cadena, Roland Siegwart, Florian Tschopp',
    journal: 'arXiv',
    date: '2022',
    comments: '',
  },
];

export default data;
